import { useEffect, useState } from 'react';
import * as yup from 'yup';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { yupResolver } from '@hookform/resolvers/yup';
import {
  connectProviderLocationDeliveryCom,
  getProviders,
  getProvidersStatuses,
} from 'redux/actions/providers';

export const initialDataModel = {
  storeId: '',
  webUrl: '',
};

const formSchema = yup.object().shape({
  storeId: yup.string().required('This field is required'),
  webUrl: yup.string().url('Invalid URL').nullable(),
});

const useDeliveryComConnect = (open, handleClose, providerSRV) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const formMethods = useForm({
    mode: 'all',
    defaultValues: initialDataModel,
    resolver: yupResolver(formSchema),
  });

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      const requestData = {
        readonly: false,
        provider: providerSRV,
        data: values,
      };
      await dispatch(connectProviderLocationDeliveryCom(requestData));
      dispatch(getProviders());
      dispatch(getProvidersStatuses());
      handleClose();
    } catch (error) {
      console.error('Error connecting provider location:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!open) {
      formMethods.reset(initialDataModel);
    }
  }, [open]);

  return {
    handleSubmit,
    loading,
    formMethods,
  };
};

export default useDeliveryComConnect;
